import { Link, useNavigate } from 'react-router-dom'
import type { Agent } from '../slices/agentsSlice'
import DeleteAgentConfirmation from './DeleteAgentConfirmation'
import './AgentsTable.css'

interface AgentsTableProps {
  agents: Agent[]
  onDelete: (id: string) => void
}

function AgentsTable({ agents, onDelete }: AgentsTableProps) {
  const navigate = useNavigate()

  function scoreDisplay(agent: Agent): number {
    return agent.total_score ?? 0
  }

  return (
    <div data-testid="agents-table" className="agents-table-wrapper">
      <div className="agents-table">
        <div data-testid="agents-table-header" className="agents-table-header">
          <span>Agent Name</span>
          <span className="agents-col-score">Score</span>
          <span className="agents-col-num">Failures</span>
          <span className="agents-col-num">Pass</span>
          <span className="agents-col-num">Fail</span>
          <span className="agents-col-num">DSQ</span>
          <span className="agents-col-num">Disagree</span>
          <span>Actions</span>
        </div>
        {agents.map((agent) => (
          <div
            key={agent.id}
            data-testid={`agent-row-${agent.id}`}
            className="agents-table-row"
            onClick={(e) => {
              if ((e.target as HTMLElement).closest('.agent-actions-cell')) return
              navigate(`/agents/${agent.id}`)
            }}
            style={{ cursor: 'pointer' }}
          >
            <span data-testid={`agent-name-${agent.id}`} className="agent-name-cell">
              <Link to={`/agents/${agent.id}`} className="agent-name-link">{agent.name}</Link>
            </span>
            <span data-testid={`agent-score-${agent.id}`} className="agent-score-cell agents-col-score">
              <span className={`score-value ${scoreDisplay(agent) > 0 ? 'positive' : scoreDisplay(agent) < 0 ? 'negative' : ''}`}>
                {scoreDisplay(agent) > 0 ? '+' : ''}{scoreDisplay(agent)}
              </span>
            </span>
            <span data-testid={`agent-count-${agent.id}`} className="agent-num-cell agents-col-num">
              {agent.failure_count ?? 0}
            </span>
            <span data-testid={`agent-pass-${agent.id}`} className="agent-num-cell agents-col-num status-pass">
              {agent.pass_count ?? 0}
            </span>
            <span data-testid={`agent-fail-${agent.id}`} className="agent-num-cell agents-col-num status-fail">
              {agent.fail_count ?? 0}
            </span>
            <span data-testid={`agent-dsq-${agent.id}`} className="agent-num-cell agents-col-num status-dsq">
              {agent.dsq_count ?? 0}
            </span>
            <span data-testid={`agent-disagree-${agent.id}`} className="agent-num-cell agents-col-num status-disagree">
              {agent.disagree_count ?? 0}
            </span>
            <span className="agent-actions-cell">
              <DeleteAgentConfirmation
                agentId={agent.id}
                onConfirm={() => onDelete(agent.id)}
              />
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AgentsTable
